<template>
  <div class="countdown-timer">
    {{ timeRemaining }}
  </div>
</template>

<script>
export default {
  data() {
    return {
      timeRemaining: '',
      timer: null,
      isBannerVisible: true,
    }
  },
  methods: {
    calculateTimeRemaining() {
      const now = new Date()
      const targetDate = new Date('2025-10-04T23:59:00')
      const timeDiff = targetDate - now

      if (timeDiff <= 0) {
        this.isBannerVisible = false
        this.$emit('countdown-finished');
        return
      }

      const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24))
      const hours = Math.floor(
        (timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      )
      const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000)

      this.timeRemaining = `${days}d ${hours}h ${minutes}m ${seconds}s`
    },
  },
  mounted() {
    this.calculateTimeRemaining()
    this.timer = setInterval(() => {
      this.calculateTimeRemaining()
      if (!this.isBannerVisible) {
        clearInterval(this.timer)
      }
    }, 1000)
  },
  beforeUnmount() {
    clearInterval(this.timer)
  },
}
</script>

<style scoped>
.countdown-timer {
  font-weight: bold;
}
</style>
